module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/21fe6f00db4a8f9d56759126ccb460d3.png";